import { useEffect } from 'react';
import { bind } from 'bind-event-listener';

import { expValEquals } from '@confluence/feature-experiments';

// Focus the main content area for live pages Full Page Editor mount. This will occur on:
// 1. Initial page load
// 2. Any page transition that lands on a live page
export const useFullPageAutoFocus = (isLivePage: boolean) => {
	useEffect(() => {
		if (
			isLivePage ||
			expValEquals('platform_editor_no_cursor_on_edit_page_init', 'isEnabled', true)
		) {
			const mainContent = document.getElementById('AkMainContent');
			// If the main content area is not found, or it already has a tabIndex set,
			// don't mess with tabIndex at all.
			if (!mainContent || mainContent.hasAttribute('tabIndex')) {
				return;
			}

			// Two-stage hydration previously masked a React execution order bug by causing this to be rendered and fired
			//  before the title component was mounted. With two-stage hydration removed, we now need to ensure that
			//  we correctly handle focus. React will fire the title component's useEffect before this one as it is on
			//  a child component of the editor. Therefore, we check here if the title is focused already, and if so,
			//  we do not steal focus away.
			if (document.activeElement?.getAttribute?.('name') === 'livepages-title') {
				return;
			}

			mainContent.setAttribute('tabIndex', '-1');
			const unbind = bind(mainContent, {
				type: 'blur',
				listener: () => {
					mainContent.removeAttribute('tabIndex');
					unbind();
				},
			});
			mainContent.focus();
			return unbind;
		}
	}, [isLivePage]);
};
